import { Grid, Box, Typography, IconButton } from "@mui/material";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import React from "react";

const CreatePassengerSeats = ({ isReturn, seats, setSeats, setReturnSeats }) => {
  const increaseStatesHandler = (seat, setState) => {
    if (seat === 1) setState(old => ({ ...old, large: old.large + 1 }));
    if (seat === 2) setState(old => ({ ...old, medium: old.medium + 1 }));
    if (seat === 3) setState(old => ({ ...old, small: old.small + 1 }));
  };

  const decreaseStatesHandler = (seat, setState) => {
    if (seat === 1) setState(old => ({ ...old, large: old.large - 1 }));
    if (seat === 2) setState(old => ({ ...old, medium: old.medium - 1 }));
    if (seat === 3) setState(old => ({ ...old, small: old.small - 1 }));
  };

  const increaseSeatsHandler = seat => {
    if (!isReturn) {
      increaseStatesHandler(seat, setSeats);
      increaseStatesHandler(seat, setReturnSeats);
    } else increaseStatesHandler(seat, setReturnSeats);
  };

  const decreaseSeatsHandler = seat => {
    if (!isReturn) decreaseStatesHandler(seat, setSeats);
    else decreaseStatesHandler(seat, setReturnSeats);
  };

  const seatTypes = [
    { label: "Velika", age: "25-36", key: "large" },
    { label: "Srednja", age: "9-18", key: "medium" },
    { label: "Mala", age: "0-9", key: "small" },
  ];

  return (
    <Box sx={{
      p: 2,
      borderRadius: 3,
      border: '1px solid #e5e7eb',
      backgroundColor: '#fafafa',
      mb: 3
    }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
        Sedišta za decu
      </Typography>

      <Grid container spacing={2}>
        {seatTypes.map((seat, index) => (
          <Grid
            key={seat.key}
            item xs={12} md={4}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>{seat.label}</Typography>
              <Typography variant="caption" color="text.secondary">{seat.age}</Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <IconButton
                size="small"
                onClick={() => decreaseSeatsHandler(index + 1)}
                disabled={seats[seat.key] <= 0}
                sx={{
                  border: '1px solid #d1d5db',
                  p: 0.5,
                  '&:hover': { backgroundColor: '#f3f4f6' },
                }}
              >
                <RemoveIcon fontSize="small" />
              </IconButton>

              <Typography sx={{ minWidth: 20, textAlign: 'center' }}>{seats[seat.key]}</Typography>

              <IconButton
                size="small"
                onClick={() => increaseSeatsHandler(index + 1)}
                sx={{
                  border: '1px solid #d1d5db',
                  p: 0.5,
                  '&:hover': { backgroundColor: '#f3f4f6' },
                }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CreatePassengerSeats;
